module.exports = __webpack_public_path__ + "static/media/pkm-niedz2.77173b9e.jpg";